import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import { setupManagementUrl } from "../../../config";
import RightsForm from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import ReportKeywordForm from "./forms";
import Joyride from "react-joyride"; // Import Joyride

const base_url = setupManagementUrl.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Report Keyword setup page, where you can manage Report Keywords.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Report Keywords by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Report Keyword.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to be able to Edit each Report Keyword from this dropdown.",
    placement: "left",
  },
];

const Excludedreportkeywords = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const actions = {
    entity: localStorage.getItem("SelectedTabLabel"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: [
        "Updateddate",
        "Createddate",
        "Createdat",
        "Updatedat",
        "Createdat",
        "Updatedby",
        "Createdby",
      ],
      objectName: "allExcludedreportkeywords",
      parameters: "",
    },
    required: "rightIds",
    isSubRight: true,
    showStatus: true,
    showMore: {
      objectname: "reportKeywordById",
      inputsubobjectname: "result",
      parameters: "id",
      search: true,
      min: 0,
      max: 5,
    },
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
          <Joyride
            steps={rightsTourSteps}
            run={runTour}
            continuous
            showSkipButton
            showProgress
            styles={{
              options: {
                primaryColor: "#1976d2",
                zIndex: 10000,
              },
            }}
          />
            {/* Top Bar */}
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
        Start Page Tour
      </Button>
    </Box>
      <DynamicTableForJson
        title="Report Keyword Management"
        subtitle="Report Keyword Management"
        FormComponent={ReportKeywordForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default Excludedreportkeywords;
